<template>
  <span>
    <v-menu
      v-model="datePickerVisible"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on, attrs }">
        <span v-if="!isOutlined" v-bind="attrs" v-on="on">
          <span class="text-no-wrap">
            <v-icon x-small class="pr-1">fa-calendar-alt</v-icon
            ><span class="dashed">{{ currentDate }}</span>
          </span>
        </span>
        <v-text-field
          :disabled="disabled"
          v-if="isOutlined"
          :outlined="isOutlined"
          v-model="currentDateFormatted"
          readonly
          :label="dateLabel ? dateLabel : ''"
          v-bind="attrs"
          v-on="on"
          hide-details="auto"
          :rules="isRequired"
        >
          <v-icon slot="append" v-on="on" :disabled="disabled"> mdi-calendar </v-icon>
        </v-text-field>
      </template>
      <v-date-picker
        :first-day-of-week="first_day_of_week"
        :min="minDate"
        v-model="currentDate"
        @input="datePickerVisible = false"
        :locale="locale"
      >
      </v-date-picker>
    </v-menu>
  </span>
</template>

<script>
import CommonMixin from "@/mixins/common";

export default {
  name: "DatePicker",
  mixins: [CommonMixin],
  props: {
    minDate: null,
    date: null,
    outlined: false,
    dateLabel: null,
    disabled: false,
    required: {
      type: Boolean,
      default: false,
    },
    dateFormat:{
      type: String,
      default: "DD.MM.YYYY"
    }
  },
  data: () => ({
    datePickerVisible: false,
  }),
  computed: {
    currentDateFormatted:{
      get(){
        return this.$moment(this.currentDate).format(this.dateFormat);
      },
      set(value){
        this.currentDate = value
      }
    },
    isOutlined() {
      return !(this.outlined === false || this.outlined === undefined);
    },
    isRequired() {
      if (this.required === true) {
        return [
          (v) => !!v || this.$t("form.validationErrors.field_is_required"),
        ];
      } else {
        return undefined;
      }
    },
    currentDate: {
      get: function () {
        let parsed;
        if (this.date) {
          parsed =
            typeof this.date === "string"
              ? this.date.substring(0, 10)
              : this.dateToTimestamp(this.date).substring(0, 10);
        }
        return this.date ? this.date : parsed;
      },
      set: function (date) {
        this.$emit("update:date", date);
        this.$emit("change", date);
      },
    },
  },
  methods: {},
};
</script>

<style scoped></style>